import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { addSupportingDoc, saveCicReviewState, getStorageSetting } from 'actions';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import FileUpload from 'components/Common/FileUpload';
import { SelectInput } from 'components/Common/Inputs';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';

class CICReviewerCommentsSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.number,
    customerId: PropTypes.number,
    cicReviewState: PropTypes.shape(),
    workflowState: PropTypes.shape(),
    validReviewer: PropTypes.bool,
    onSubmit: PropTypes.func,
    isSavingCicReviewState: PropTypes.bool
  };

  static defaultProps = {
    permissions: null,
    id: null,
    customerId: null,
    cicReviewState: null,
    workflowState: null,
    validReviewer: true,
    onSubmit: null,
    isSavingCicReviewState: false
  };

  constructor(props) {
    super(props);

    const files = getStorageSetting('files') || [];

    this.state = {
      supportingDocType: '',
      files,
      assignToUser: null,
      draftComments: props.cicReviewState ? props.cicReviewState.draftComments : ''
    };
  }

  static onFileUploadCancel(file) {
    toastr.info('', `Upload of ${ file.name } has been canceled.`);
  }

  static onFileUploadError(file, error) {
    toastr.error('', `Upload of ${ file.name } has been canceled.  ${ error.message }`);
  }

  onFileUploadSuccess(file, response) {
    const { dispatch } = this.props;
    dispatch(addSupportingDoc(response));
    toastr.success('', `${ response[0].originalFileName } has been uploaded`);
  }

  onSupportingDocTypeChange = (e, newValue) => this.setState({ supportingDocType: newValue });

  onAssignToUserSelectedItem = (lookupValue) => {
    this.setState({ assignToUser: lookupValue });
  }

  onAssignToUserChange = (e, value) => {
    const { assignToUser } = this.state;

    if (value === '') {
      this.setState({ assignToUser: null });
    }

    if (assignToUser && assignToUser.value !== value) {
      this.setState({ assignToUser: null });
    }
  }

  onDraftCommentsChange = (e, value) => this.setState({ draftComments: value });

  onCopyAllPreviousComments = () => {
    const { dispatch, cicReviewState } = this.props;

    if (cicReviewState && cicReviewState.previousComments) {
      const copiedComments = cicReviewState.previousComments.join('\n');
      this.setState({ draftComments: copiedComments });
      dispatch(change('cicReviewerForm', 'reviewerComment', copiedComments));
    }
  }

  onCopyComment = (comment) => {
    const { dispatch } = this.props;
    this.setState({ draftComments: comment.comm });
    dispatch(change('cicReviewerForm', 'reviewerComment', comment.comm));
  }

  onFormSubmit = (actionId) => {
    const { dispatch, id, onSubmit } = this.props;
    const { draftComments, assignToUser } = this.state;

    if (onSubmit != null) {
      onSubmit(id, {
        actionId,
        draftComments,
        assignToUser
      });
    } else {
      dispatch(saveCicReviewState(id, {
        actionId,
        draftComments,
        assignToUser
      }));
    }

    if (actionId) {
      dispatch(change('cicReviewerForm', 'reviewerComment', ''));
    }
  }

  getReviewerStage() {
    const { cicReviewState } = this.props;

    if (cicReviewState != null) {
      if (cicReviewState.workflowStage >= 3 && cicReviewState.workflowStage <= 4) {
        return 'Initial Reviewer';
      }
      if (cicReviewState.workflowStage >= 5 && cicReviewState.workflowStage <= 6) {
        return 'Secondary Reviewer';
      }
      if (cicReviewState.workflowStage >= 7 && cicReviewState.workflowStage <= 8) {
        return 'Expert Reviewer';
      }
    }
    return 'My';
  }

  canComment() {
    const { permissions, cicReviewState, workflowState, validReviewer } = this.props;
    if (!validReviewer) {
      return false;
    }

    const isOwner = workflowState != null && workflowState.assignedUser === getStorageSetting('username');
    const hasReviewerPermission = AccessControl.hasPermission(permissions, [ActivityPerms.cicwfInitialReviewer, ActivityPerms.cicwfSecondaryReviewer, ActivityPerms.cicwfExpertReviewer, ActivityPerms.cicwfSupplReviewer]);

    if (cicReviewState != null && cicReviewState.workflowStage != null && cicReviewState.workflowStage === 100) {
      // WF is complete
      return AccessControl.hasPermission(permissions, [ActivityPerms.cicwfExpertReviewer, ActivityPerms.cicwfSupplReviewer]);
    }

    return isOwner && hasReviewerPermission;
  }

  render() {
    const {
      permissions,
      customerId,
      cicReviewState,
      isSavingCicReviewState
    } = this.props;
    const { files, supportingDocType, draftComments, assignToUser } = this.state;
    return (
      <div className="reviewer-comments">
        <div className="reviewer-comments-content">
          <form
            id="cicReviewerForm"
            className="form-horizontal side-bar-form"
          >
            <label htmlFor="previous-comments" className="form-label">Previous Reviewer(s) Comment(s)</label>
            { !this.canComment() && (!cicReviewState
              || !cicReviewState.previousComments
              || cicReviewState.previousComments.length === 0) && <span>No comments made.</span> }
            { cicReviewState != null && cicReviewState.previousComments && <div className="previous-comments">
              { // eslint-disable-next-line
                cicReviewState.previousComments.map((comm, index) => comm != null && <p key={ index }>
                  { this.canComment() && <button
                    className="btn btn-sm copy-icon"
                    type="button"
                    title="Copy comment"
                    onClick={ () => this.onCopyComment({ comm }) }
                  >
                    <span className="icon icon-copy" />
                  </button> }
                  { // eslint-disable-next-line
                    comm != null && comm.split('\n') && comm.split('\n').map((item, index) => item != null && <React.Fragment key={ index }>{ item }<br /></React.Fragment>) 
                  }</p>)
              }
              { this.canComment() && <label htmlFor="draft-comments" className="form-label comments-title">
                { this.getReviewerStage() } Comments
                <button type="button" className="btn btn-primary" onClick={ () => this.onCopyAllPreviousComments() }>Copy All</button>
              </label> }
            </div> }
            { this.canComment() && <div className="form-group col-12">
              <p>Insert in the box any additional information supplied or sourced.</p>
              <Field
                id="reviewer-comments"
                name="reviewerComment"
                component="textarea"
                { ... { rows: '5', maxLength: '2000' } }
                className="form-input"
                normalize={ value => value.substring(0, 2000) }
                value={ draftComments }
                onChange={ (e, value) => this.onDraftCommentsChange(e, value) }
              />
            </div> }
            { this.canComment() && <AccessControl permissions={ permissions } allowedPermissions={ [ActivityPerms.scannedSupDocs] }>
              <div className="document-drop form-group">
                <div className="col-4 col-sm-12">
                  <label htmlFor="supporting-doc-type" className="form-label">Document Type</label>
                </div>
                <div className="col-8 col-sm-12">
                  <Field
                    id="supporting-doc-type"
                    name="supportingDocType"
                    component={ SelectInput }
                    className="form-select"
                    hideHints
                    value={ supportingDocType }
                    onChange={ (e, newValue) => this.onSupportingDocTypeChange(e, newValue) }
                  >
                    <option value="" disabled>Choose a document type</option>
                    <option value="affidavitstatingnotprivatefoundation">Affidavit Stating Not Private Foundation</option>
                    <option value="armedforcesidcard">Armed Forces ID Card</option>
                    <option value="articleassoc">Articles of Association</option>
                    <option value="articleincorp">Articles of Incorporation</option>
                    <option value="auditorsletter">Auditor&apos;s Letter</option>
                    <option value="bankidcard">Bank ID Card</option>
                    <option value="cedula">Cedula</option>
                    <option value="certincorp">Certificate of Incorporation</option>
                    <option value="certltdpartner">Certificate of Limited Partnership</option>
                    <option value="certlossnationality">Certificate of Loss of Nationality</option>
                    <option value="certpartnership">Certificate of Partnership</option>
                    <option value="certreg">Certificate of Registration</option>
                    <option value="certofresidence">Certificate of Residence</option>
                    <option value="controllingpersonselfcertification">Controlling Person Self-Certification</option>
                    <option value="dateofbirthsupportingdoc">Date of Birth Supporting Doc</option>
                    <option value="drivinglicence">Driver’s License</option>
                    <option value="form8832">Form 8832</option>
                    <option value="irsdeterminationletter">IRS Determination Letter</option>
                    <option value="liquidationandbankruptcy">Liquidation and Bankruptcy</option>
                    <option value="memorandum">Memorandum of Association</option>
                    <option value="nationalidcard">National ID Card</option>
                    <option value="opinionfromuscounsel">Opinion From U.S. Counsel</option>
                    <option value="othergovid">Other Government ID</option>
                    <option value="ownerreportingstatement">Owner Reporting Statement</option>
                    <option value="partnership">Partnership Agreement</option>
                    <option value="passport">Passport</option>
                    <option value="permitofresidence">Permit of Residence</option>
                    <option value="powerofattorney">Power Of Attorney</option>
                    <option value="qdddocumentation">QDD Documentation</option>
                    <option value="qslstatement">QSL Statement</option>
                    <option value="writtenexplanation">Reasonable Written Explanation</option>
                    <option value="regcert">Registration Certificate</option>
                    <option value="taxpayercert">Taxpayer Certificate</option>
                    <option value="tinnotissued">Tin Not Issued</option>
                    <option value="trustagreement">Trust Agreement</option>
                    <option value="trustdeed">Trust Deed</option>
                    <option value="trusteedocumentedtrustletter">Trustee Documented Trust Letter</option>
                    <option value="votercard">Voter Registration Card</option>
                    <option value="will">Will</option>
                    <option value="notlisted">Other document type not listed above</option>
                  </Field>
                </div>
              </div>
              <FileUpload
                defaultMessage="Drop files here to upload in bmp, gif, jpg, png, tif, doc, docx, xls, xlsx, msg or pdf format"
                postUrl={ ApiService.getFileUploadUrl() }
                accessTokenName={ ApiService.getAccessTokenName() }
                acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx"
                maxFilesize={ files.maxFilesize }
                timeout={ files.uploadTimeout }
                docCategory="supportingdocument"
                docType={ supportingDocType != null ? supportingDocType : '' }
                linkType="customer"
                id={ customerId }
                onFileUploadCancel={ file => CICReviewerCommentsSection.onFileUploadCancel(file) }
                onFileUploadSuccess={ (file, response) => this.onFileUploadSuccess(file, response) }
                onFileUploadError={ (file, error) => CICReviewerCommentsSection.onFileUploadError(file, error) }
              />
            </AccessControl> }
            { this.canComment() && <div className="assign-to-user form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="assigned-user" className="form-label">Assign To User</label>
              </div>
              <div className="col-8 col-sm-12">
                <AutoCompleteInput
                  id="assigned-user"
                  name="assignToUser"
                  category="user"
                  placeholder="Enter user name..."
                  value={ assignToUser || '' }
                  onSelectedItem={ lookupValue => this.onAssignToUserSelectedItem(lookupValue) }
                  onChange={ (e, value) => this.onAssignToUserChange(e, value) }
                />
              </div>
            </div> }
            { this.canComment() && <div className="review-actions form-group">
              { cicReviewState != null && cicReviewState.availableActions != null && <div className="workflow-actions col-12">
                { Object.entries(cicReviewState.availableActions) != null && Object.entries(cicReviewState.availableActions)
                  .filter(([key, value]) => value != null && value !== 'Submit').map(([key, value]) => key != null && <div key={ key } className="col-6">
                    <button
                      value={ value }
                      className="btn text-ellipsis"
                      title={ value }
                      type="button"
                      disabled={ isSavingCicReviewState }
                      onClick={ () => this.onFormSubmit(key) }
                    >
                      { value }
                    </button>
                  </div>) }
              </div> }
              <div className="submit-actions col-12">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={ isSavingCicReviewState }
                    onClick={ () => this.onFormSubmit(null) }
                  >
                    Save { assignToUser && ' and Assign' }
                  </button>
                </div>
                <div className="col-6">
                  { cicReviewState && cicReviewState.availableActions && Object.entries(cicReviewState.availableActions) != null && Object.entries(cicReviewState.availableActions)
                    .filter(([key, value]) => value != null && value === 'Submit').map(([key, value]) => key != null && <button
                      key={ key }
                      value={ value }
                      className="btn btn-primary review-submit"
                      type="button"
                      disabled={ isSavingCicReviewState }
                      onClick={ () => this.onFormSubmit(key) }
                    >
                      { value }
                    </button>) }
                </div>
              </div>
            </div> }
          </form>
        </div>
      </div>
    );
  }
}

const cicReviewerForm = reduxForm({
  form: 'cicReviewerForm',
})(CICReviewerCommentsSection);

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    rtks: {
      isSavingCicReviewState,
      cicReviewState,
      workflowState
    }
  } = state;

  return {
    permissions,
    isSavingCicReviewState,
    cicReviewState,
    workflowState,
    initialValues: {
      reviewerComment: cicReviewState ? cicReviewState.draftComments : ''
    }
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const CICReviewerComments = connect(
  mapStateToProps,
  mapDispatchToProps
)(cicReviewerForm);

export default CICReviewerComments;
